import React, { useEffect, useRef } from 'react';
import EventItem from './EventItem';

const EventList = ({ events }) => {
    let previousPeriod = null;
    const currentMonthRef = useRef(null);
    const today = new Date();

    useEffect(() => {
        if (currentMonthRef.current) {
            const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
            currentMonthRef.current.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
        }
    }, [events]);


    return (
        <div className="scroll-container">
            <ul className="event-list">
                {events.map((event) => {
                    // divide months
                    const currMonth = new Date(event.startDate).getUTCMonth();
                    const currYear = new Date(event.startDate).getUTCFullYear();
                    const currentPeriod = `${currYear}-${currMonth}`;
                    const isCurrentMonth = currMonth === today.getUTCMonth() && currYear === today.getUTCFullYear();
                    const eventKey = event.id || `${event.name}-${event.startDate.toISOString()}`;
                    let separator = null;

                    if (currentPeriod !== previousPeriod) {
                        separator = 
                            <li className="month-separator-item">
                                <h2
                                    ref={isCurrentMonth ? currentMonthRef : null}
                                    className={`month-separator${isCurrentMonth ? ' month-separator-current' : ''}`}>
                                        <span>{getMonthName(currMonth)}, {currYear}</span>
                                        {isCurrentMonth && (
                                            <span className="month-status-badge">Upcoming</span>
                                        )}
                                </h2>
                            </li>;
                    }

                    previousPeriod = currentPeriod;

                    return (
                        <React.Fragment key={eventKey}>
                            {separator}
                            <li className="event-list-li">
                                <EventItem e={event}/>
                            </li>
                        </React.Fragment>
                    );
                })}
            </ul>
        </div>
    );
};

function getMonthName(monthIndex) {
    const months = [
        'JANUARY', 'FEBRUARY', 'MARCH', 'APRIL',
        'MAY', 'JUNE', 'JULY', 'AUGUST',
        'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'
    ];
    return months[monthIndex];
}

export default EventList;
